import * as React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { SystemTranslationKeys } from '@common/entities';

import { useSystemTranslation } from 'hooks';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onClickAction: () => void;
  modalText: string;
  actionBtnText?: string;
  closeBtnText?: string;
  actionBtnVariant: 'success' | 'caution' | 'danger' | 'neutral' | 'brand' | 'action';
  isLoading?: boolean;
  loadingText?: string;
}
export function ConfirmationModal(props: Props) {
  const { tSystem } = useSystemTranslation();
  const {
    isOpen,
    onClose,
    onClickAction,
    modalText,
    actionBtnText = tSystem(SystemTranslationKeys.common.submit),
    closeBtnText = tSystem(SystemTranslationKeys.common.close),
    actionBtnVariant = 'success',
    isLoading,
    loadingText,
  } = props;

  return (
    <Modal size="sm" isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay bg="black.200" backdropFilter="blur(12px) hue-rotate(0deg)" />
      <ModalContent bg="white.base" border="1px" borderColor="gray.light" borderRadius="md">
        <ModalBody px={6} py={8}>
          <Text textAlign="center" wordBreak="break-word">
            {modalText}
          </Text>
        </ModalBody>
        <ModalFooter
          borderBottomRightRadius="md"
          borderBottomLeftRadius="md"
          bg="silver.essence"
          py={3}
        >
          <Button size="sm" onClick={onClose} mr={4} isDisabled={isLoading}>
            {closeBtnText}
          </Button>
          <Button
            size="sm"
            variant={actionBtnVariant}
            onClick={onClickAction}
            isLoading={isLoading}
            loadingText={loadingText}
            isDisabled={isLoading}
          >
            {actionBtnText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
